import React from "react";
import {
  CollapsibleProps,
  Collapsibles,
  CollapsiblesProps,
} from "../components/Collapsibles";
import { CtaLine, CtaLineProps } from "../components/CtaLine";
import { Deco } from "../components/Deco";
import { Figure, FigureProps } from "../components/Figure";
import { Grid } from "../layouts/Grid";
import { MaxWidth } from "../layouts/MaxWidth";
import { Spacing } from "../layouts/Spacing";
import styles from "./SectorInfo.module.css";

export type SectorInfoProps = {
  title: string;
  text: string;
  image: FigureProps["image"];
  items: CollapsibleProps[];
  cta: CtaLineProps;
};

export const SectorInfo = ({
  title,
  text,
  image,
  items,
  cta,
}: SectorInfoProps) => {
  if (!items || !text) return null;
  const hasCta = (cta && cta?.url) || false;
  return (
    <Spacing>
      <MaxWidth size="lg">
        <Grid layout="split-65">
          <div>
            <h2 className={styles.title}>
              <Deco deco="dot">{title}</Deco>
            </h2>
            <p>{text}</p>
            <Collapsibles items={items} />
          </div>
          <Figure
            image={image}
            className={styles.figure}
            width={460}
            height={575}
          />
        </Grid>
        {hasCta && (
          <Spacing top="sm" bottom="none">
            <CtaLine {...cta} className={styles.ctaLine} />
          </Spacing>
        )}
      </MaxWidth>
    </Spacing>
  );
};
